// ============================================================================
// PeriodPicker (E2, F-507) — selecteur de mois deep-linkable `?period=YYYY-MM`
// ============================================================================
// Portage du PoC components/finance/period-picker.tsx : `router.replace` (Next) ->
// `setSearchParams({ replace: true })` (react-router) — meme effet, la periode ne
// pollue pas l'historique de navigation. Une valeur malformee n'est jamais emise
// (garde de forme ici ; le serveur replie de son cote, M-506).

import { useSearchParams } from 'react-router-dom';
import { useTranslation } from '../../i18n';

const PERIOD_RE = /^\d{4}-\d{2}$/;

export interface PeriodPickerProps {
  /** Periode RETENUE par le serveur (M-506) — jamais le param brut de l'URL. */
  value: string;
}

export function PeriodPicker({ value }: PeriodPickerProps) {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();

  function onChange(next: string) {
    if (!PERIOD_RE.test(next)) return;
    const params = new URLSearchParams(searchParams);
    params.set('period', next);
    setSearchParams(params, { replace: true });
  }

  return (
    <label className="flex items-center gap-2 text-field">
      <span className="text-slate-500 dark:text-slate-400">{t('gest:finance.period.label')}</span>
      <input
        type="month"
        value={value}
        onChange={(e) => onChange(e.currentTarget.value)}
        className="touch-manipulation rounded-lg border border-slate-200 bg-white px-2 py-1 text-field text-slate-800 focus:border-brand-500 focus:outline-hidden focus:ring-2 focus:ring-brand-500/40 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-100"
      />
    </label>
  );
}
